import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "head-container" }
const _hoisted_3 = { class: "head-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("更多")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("重置密码")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("分配角色")
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("将文件拖到此处，或"),
  /*#__PURE__*/_createElementVNode("em", null, "点击上传")
], -1)
const _hoisted_21 = { class: "el-upload__tip" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 是否更新已经存在的用户数据 ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "仅允许导入xls、xlsx格式文件。", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("下载模板")
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取 消")

import { ref, reactive, watch, onMounted, nextTick, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { ElTree, ElForm, ElUpload, FormInstance, FormRules, ElMessage, ElMessageBox } from 'element-plus';
import { 
  Search, Refresh, Plus, Edit, Delete, 
  Upload, Download, ArrowRight, Key, Check, 
  UploadFilled
} from '@element-plus/icons-vue';
import { listUser, getUser, delUser, addUser, updateUser, resetUserPwd, changeUserStatus, deptTreeSelect } from "@/service/main/system/user";
import { getToken } from "@/utils/auth";
import Treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import { parseTime, addDateRange } from '@/utils/ruoyi';
import hyRequest from '@/service'

import type { UserFormData, UserQueryParams, DeptOption, PostOption, RoleOption, UserListItem, Column } from './types';


// 路由

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();

// 获取组件实例
const { proxy } = getCurrentInstance() as any;

// DOM引用
const treeRef = ref<InstanceType<typeof ElTree>>();
const queryFormRef = ref<FormInstance>();
const formRef = ref<FormInstance>();
const uploadRef = ref<InstanceType<typeof ElUpload>>();

// 遮罩层
const loading = ref(true);
// 选中数组
const ids = ref<number[]>([]);
// 非单个禁用
const single = ref(true);
// 非多个禁用
const multiple = ref(true);
// 显示搜索条件
const showSearch = ref(true);
// 总条数
const total = ref(0);
// 用户表格数据
const userList = ref<UserListItem[]>([]);
// 弹出层标题
const title = ref('');
// 部门树选项
const deptOptions = ref<DeptOption[]>([]);
// 是否显示弹出层
const open = ref(false);
// 部门名称
const deptName = ref('');
// 默认密码
const initPassword = ref('');
// 日期范围
const dateRange = ref<[string, string]>(['', '']);
// 岗位选项
const postOptions = ref<PostOption[]>([]);
// 角色选项
const roleOptions = ref<RoleOption[]>([]);

// 字典对象
const dict = reactive({
  type: {
    sys_normal_disable: [],
    sys_user_sex: []
  }
});

// 表单参数
const form = reactive<UserFormData>({
  userId: undefined,
  deptId: undefined,
  userName: '',
  nickName: '',
  password: '',
  phonenumber: '',
  email: '',
  sex: '',
  status: '0',
  remark: '',
  postIds: [],
  roleIds: []
});

// 默认树属性
const defaultProps = {
  children: "children",
  label: "label"
};

// 用户导入参数
const upload = reactive({
  open: false,
  title: '',
  isUploading: false,
  updateSupport: false,
  headers: { Authorization: "Bearer " + getToken() },
  url: process.env.VUE_APP_BASE_API + "/system/user/importData"
});

// 查询参数
const queryParams = reactive<UserQueryParams>({
  pageNum: 1,
  pageSize: 10,
  userName: '',
  phonenumber: '',
  status: '',
  deptId: undefined
});

// 列信息
const columns = ref<Column[]>([
  { key: 0, label: '用户编号', visible: true },
  { key: 1, label: '用户名称', visible: true },
  { key: 2, label: '用户昵称', visible: true },
  { key: 3, label: '部门', visible: true },
  { key: 4, label: '手机号码', visible: true },
  { key: 5, label: '状态', visible: true },
  { key: 6, label: '创建时间', visible: true }
]);

// 加载字典数据
const loadDicts = () => {
  proxy.getDicts("sys_normal_disable").then((response: any) => {
    dict.type.sys_normal_disable = response.data.map((item: any) => ({
      value: item.dictValue,
      label: item.dictLabel
    }));
  });
  proxy.getDicts("sys_user_sex").then((response: any) => {
    dict.type.sys_user_sex = response.data.map((item: any) => ({
      value: item.dictValue,
      label: item.dictLabel
    }));
  });
};

// 表单校验
const rules = reactive<FormRules>({
  userName: [
    { required: true, message: "用户名称不能为空", trigger: "blur" },
    { min: 2, max: 20, message: '用户名称长度必须介于 2 和 20 之间', trigger: 'blur' }
  ],
  nickName: [
    { required: true, message: "用户昵称不能为空", trigger: "blur" }
  ],
  password: [
    { required: true, message: "用户密码不能为空", trigger: "blur" },
    { min: 5, max: 20, message: '用户密码长度必须介于 5 和 20 之间', trigger: 'blur' },
    { pattern: /^[^<>"'|\\]+$/, message: "不能包含非法字符：< > \" ' \\ |", trigger: "blur" }
  ],
  email: [
    {
      type: "email",
      message: "请输入正确的邮箱地址",
      trigger: ["blur", "change"]
    }
  ],
  phonenumber: [
    {
      pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
      message: "请输入正确的手机号码",
      trigger: "blur"
    }
  ]
});

// 监听部门名称变化
watch(deptName, (val) => {
  treeRef.value?.filter(val);
});

// 生命周期钩子
onMounted(() => {
  getList();
  getDeptTree();
  loadDicts();
  getUserInfo()
  getConfigKey("sys.user.initPassword").then(response => {
    initPassword.value = response.msg;
  });
});

// 方法

/** 查询用户列表 */
function getList() {
  loading.value = true;
  listUser(addDateRange(queryParams, dateRange.value)).then(response => {
    userList.value = response?.rows || [];
    total.value = response?.total || 0;
    loading.value = false;
  }).catch(error => {
    console.error('获取用户列表失败:', error);
    userList.value = [];
    total.value = 0;
    loading.value = false;
  });
}

/** 查询部门下拉树结构 */
function getDeptTree() {
  deptTreeSelect().then(response => {
    deptOptions.value = response.data || [];
  }).catch(error => {
    console.error('获取部门树失败:', error);
    deptOptions.value = [];
  });
}

// 筛选节点
function filterNode(value: string, data: any) {
  if (!value) return true;
  return data.label.indexOf(value) !== -1;
}

// 节点单击事件
function handleNodeClick(data: any) {
  queryParams.deptId = data.id;
  handleQuery();
}

// 用户状态修改
function handleStatusChange(row: UserListItem) {
  let text = row.status === "0" ? "启用" : "停用";
  ElMessageBox.confirm('确认要"' + text + '""' + row.userName + '"用户吗？').then(function() {
    return changeUserStatus(row.userId, row.status);
  }).then(() => {
    ElMessage.success(text + "成功");
  }).catch(function() {
    row.status = row.status === "0" ? "1" : "0";
  });
}

// 取消按钮
function cancel() {
  open.value = false;
  reset();
}

// 表单重置
function reset() {
  form.userId = undefined;
  form.deptId = undefined;
  form.userName = '';
  form.nickName = '';
  form.password = '';
  form.phonenumber = '';
  form.email = '';
  form.sex = '';
  form.status = '0';
  form.remark = '';
  form.postIds = [];
  form.roleIds = [];
  nextTick(() => {
    formRef.value?.resetFields();
  });
}

/** 搜索按钮操作 */
function handleQuery() {
  queryParams.pageNum = 1;
  getList();
}

/** 重置按钮操作 */
function resetQuery() {
  dateRange.value = ['', ''];
  nextTick(() => {
    queryFormRef.value?.resetFields();
  });
  queryParams.deptId = undefined;
  treeRef.value?.setCurrentKey(undefined);
  handleQuery();
}

// 多选框选中数据
function handleSelectionChange(selection: UserListItem[]) {
  ids.value = selection.map(item => item.userId);
  single.value = selection.length !== 1;
  multiple.value = !selection.length;
}

// 更多操作触发
function handleCommand(command: string, row: UserListItem) {
  switch (command) {
    case "handleResetPwd":
      handleResetPwd(row);
      break;
    case "handleAuthRole":
      handleAuthRole(row);
      break;
    default:
      break;
  }
}

function getUserInfo() {
  getUser('').then(response => {
    console.log('response',response)
    postOptions.value = response?.posts || [];
    roleOptions.value = response?.roles || [];
  })
}
/** 新增按钮操作 */
function handleAdd() {
  reset();
  open.value = true;
    title.value = "添加用户";
    form.password = initPassword.value;
}

/** 修改按钮操作 */
function handleUpdate(row?: UserListItem) {
  reset();
  const userId = row?.userId || ids.value[0];
  getUser(userId).then(response => {
    Object.assign(form, response.data);
    postOptions.value = response?.posts || [];
    roleOptions.value = response?.roles || [];
    form.postIds = response?.postIds || [];
    form.roleIds = response?.roleIds || [];
    open.value = true;
    title.value = "修改用户";
    form.password = "";
  }).catch(error => {
    console.error('获取用户信息失败:', error);
  });
}

/** 重置密码按钮操作 */
function handleResetPwd(row: UserListItem) {
  ElMessageBox.prompt('请输入"' + row.userName + '"的新密码', "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    closeOnClickModal: false,
    inputPattern: /^.{5,20}$/,
    inputErrorMessage: "用户密码长度必须介于 5 和 20 之间",
    inputValidator: (value) => {
      if (/<|>|"|'|\||\\/.test(value)) {
        return "不能包含非法字符：< > \" ' \\ |"
      }
      return true;
    },
  }).then(({ value }) => {
    resetUserPwd(row.userId, value).then(response => {
      console.log('response',response)
      ElMessage.success("修改成功，新密码是：" + value);
    });
  }).catch(() => {
    // 处理取消修改密码的情况
  });
}

/** 分配角色操作 */
function handleAuthRole(row: UserListItem) {
  const userId = row.userId;
  const targetPath = "/system/user-auth/role/" + userId;
  console.log('跳转到分配角色页面:', targetPath, '用户ID:', userId);
  console.log('当前路由:', router.currentRoute.value.path);
  
  // 检查路由是否存在
  const routes = router.getRoutes();
  const targetRoute = routes.find(r => r.path === '/system/user-auth/role/:userId(\\d+)');
  console.log('目标路由是否存在:', !!targetRoute, targetRoute);
  
  router.push(targetPath).then(() => {
    console.log('路由跳转成功，当前路径:', router.currentRoute.value.path);
    console.log('当前路由对象:', router.currentRoute.value);
  }).catch((err) => {
    console.error('路由跳转失败:', err);
  });
}

/** 提交按钮 */
function submitForm() {
  formRef.value?.validate(valid => {
    if (valid) {
      if (form.userId !== undefined) {
        updateUser(form).then(response => {
          console.log('response',response)
          ElMessage.success("修改成功");
          open.value = false;
          getList();
        });
      } else {
        addUser(form).then(response => {
          console.log('response',response)
          ElMessage.success("新增成功");
          open.value = false;
          getList();
        });
      }
    }
  });
}

/** 删除按钮操作 */
function handleDelete(row?: UserListItem) {
  const userIds = row?.userId || ids.value[0];
  ElMessageBox.confirm('是否确认删除用户编号为"' + userIds + '"的数据项？').then(function() {
    return delUser(userIds);
  }).then(() => {
    getList();
    ElMessage.success("删除成功");
  }).catch(() => {
    // 处理取消删除的情况
  });
}

/** 导出按钮操作 */
function handleExport() {
  hyRequest.download('system/user/export', {
    ...queryParams
  }, `user_${new Date().getTime()}.xlsx`);
}

/** 导入按钮操作 */
function handleImport() {
  upload.title = "用户导入";
  upload.open = true;
}

/** 下载模板操作 */
function importTemplate() {
  hyRequest.download('system/user/importTemplate', {}, `user_template_${new Date().getTime()}.xlsx`);
}

// 文件上传中处理
function handleFileUploadProgress(event: any, file: any, fileList: any[]) {
  upload.isUploading = true;
}

// 文件上传成功处理
function handleFileSuccess(response: any, file: any, fileList: any[]) {
  upload.open = false;
  upload.isUploading = false;
  uploadRef.value?.clearFiles();
  ElMessageBox.alert(`<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>${response.msg}</div>`, "导入结果", { 
    dangerouslyUseHTMLString: true 
  });
  getList();
}

// 提交上传文件
function submitFileForm() {
  uploadRef.value?.submit();
}

// 全局配置
function getConfigKey(key: string) {
  return Promise.resolve({ msg: "123456" }); // 这里需要替换为实际的API调用
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_right_toolbar = _resolveComponent("right-toolbar")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_link = _resolveComponent("el-link")!
  const _directive_hasPermi = _resolveDirective("hasPermi")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 4,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_input, {
                modelValue: deptName.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((deptName).value = $event)),
                placeholder: "请输入部门名称",
                clearable: "",
                size: "small",
                "prefix-icon": _unref(Search),
                style: {"margin-bottom":"20px"}
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(ElTree), {
                data: deptOptions.value,
                props: defaultProps,
                "expand-on-click-node": false,
                "filter-node-method": filterNode,
                ref_key: "treeRef",
                ref: treeRef,
                "node-key": "id",
                "default-expand-all": "",
                "highlight-current": "",
                onNodeClick: handleNodeClick
              }, null, 8, ["data"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 20,
          xs: 24
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_unref(ElForm), {
              model: queryParams,
              ref_key: "queryFormRef",
              ref: queryFormRef,
              size: "small",
              inline: true,
              "label-width": "68px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "用户名称",
                  prop: "userName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryParams.userName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.userName) = $event)),
                      placeholder: "请输入用户名称",
                      clearable: "",
                      style: {"width":"240px"},
                      onKeyup: _withKeys(handleQuery, ["enter"])
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "手机号码",
                  prop: "phonenumber"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryParams.phonenumber,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.phonenumber) = $event)),
                      placeholder: "请输入手机号码",
                      clearable: "",
                      style: {"width":"240px"},
                      onKeyup: _withKeys(handleQuery, ["enter"])
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "状态",
                  prop: "status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryParams.status,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.status) = $event)),
                      placeholder: "用户状态",
                      clearable: "",
                      style: {"width":"240px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dict.type.sys_normal_disable, (dict) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: dict.value,
                            label: dict.label,
                            value: dict.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "创建时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: dateRange.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dateRange).value = $event)),
                      style: {"width":"240px"},
                      "value-format": "YYYY-MM-DD",
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: _unref(Search),
                      size: "small",
                      onClick: handleQuery
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      icon: _unref(Refresh),
                      size: "small",
                      onClick: resetQuery
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]), [
              [_vShow, showSearch.value]
            ]),
            _createVNode(_component_el_row, {
              gutter: 10,
              class: "mb8"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 1.5 }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      type: "primary",
                      plain: "",
                      icon: _unref(Plus),
                      size: "small",
                      onClick: handleAdd
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["icon"])), [
                      [_directive_hasPermi, ['system:user:add']]
                    ])
                  ]),
                  _: 1
                }, 8, ["span"]),
                _createVNode(_component_el_col, { span: 1.5 }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      type: "success",
                      plain: "",
                      icon: _unref(Edit),
                      size: "small",
                      disabled: single.value,
                      onClick: handleUpdate
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["icon", "disabled"])), [
                      [_directive_hasPermi, ['system:user:edit']]
                    ])
                  ]),
                  _: 1
                }, 8, ["span"]),
                _createVNode(_component_el_col, { span: 1.5 }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      type: "danger",
                      plain: "",
                      icon: _unref(Delete),
                      size: "small",
                      disabled: multiple.value,
                      onClick: handleDelete
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["icon", "disabled"])), [
                      [_directive_hasPermi, ['system:user:remove']]
                    ])
                  ]),
                  _: 1
                }, 8, ["span"]),
                _createVNode(_component_el_col, { span: 1.5 }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      type: "info",
                      plain: "",
                      icon: _unref(Upload),
                      size: "small",
                      onClick: handleImport
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["icon"])), [
                      [_directive_hasPermi, ['system:user:import']]
                    ])
                  ]),
                  _: 1
                }, 8, ["span"]),
                _createVNode(_component_el_col, { span: 1.5 }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      type: "warning",
                      plain: "",
                      icon: _unref(Download),
                      size: "small",
                      onClick: handleExport
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["icon"])), [
                      [_directive_hasPermi, ['system:user:export']]
                    ])
                  ]),
                  _: 1
                }, 8, ["span"]),
                _createVNode(_component_right_toolbar, {
                  showSearch: showSearch.value,
                  "onUpdate:showSearch": _cache[5] || (_cache[5] = ($event: any) => ((showSearch).value = $event)),
                  onQueryTable: getList,
                  columns: columns.value
                }, null, 8, ["showSearch", "columns"])
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: userList.value,
              onSelectionChange: handleSelectionChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "50",
                  align: "center"
                }),
                (columns.value[0].visible)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      label: "用户编号",
                      align: "center",
                      key: "userId",
                      prop: "userId"
                    }))
                  : _createCommentVNode("", true),
                (columns.value[1].visible)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      label: "用户名称",
                      align: "center",
                      key: "userName",
                      prop: "userName",
                      "show-overflow-tooltip": true
                    }))
                  : _createCommentVNode("", true),
                (columns.value[2].visible)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      label: "用户昵称",
                      align: "center",
                      key: "nickName",
                      prop: "nickName",
                      "show-overflow-tooltip": true
                    }))
                  : _createCommentVNode("", true),
                (columns.value[3].visible)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      label: "部门",
                      align: "center",
                      key: "deptName",
                      prop: "dept.deptName",
                      "show-overflow-tooltip": true
                    }))
                  : _createCommentVNode("", true),
                (columns.value[4].visible)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      label: "手机号码",
                      align: "center",
                      key: "phonenumber",
                      prop: "phonenumber",
                      width: "120"
                    }))
                  : _createCommentVNode("", true),
                (columns.value[5].visible)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      label: "状态",
                      align: "center",
                      key: "status"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_switch, {
                          modelValue: scope.row.status,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.status) = $event),
                          "active-value": "0",
                          "inactive-value": "1",
                          onChange: () => handleStatusChange(scope.row)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (columns.value[6].visible)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 6,
                      label: "创建时间",
                      align: "center",
                      prop: "createTime",
                      width: "160"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", null, _toDisplayString(_unref(parseTime)(scope.row.createTime)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  align: "center",
                  width: "160",
                  "class-name": "small-padding fixed-width"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.userId !== 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                            size: "small",
                            type: "text",
                            icon: _unref(Edit),
                            onClick: ($event: any) => (handleUpdate(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 2
                          }, 1032, ["icon", "onClick"])), [
                            [_directive_hasPermi, ['system:user:edit']]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                            size: "small",
                            type: "text",
                            icon: _unref(Delete),
                            onClick: ($event: any) => (handleDelete(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 2
                          }, 1032, ["icon", "onClick"])), [
                            [_directive_hasPermi, ['system:user:remove']]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_el_dropdown, {
                            size: "small",
                            onCommand: (command) => handleCommand(command, scope.row)
                          }, {
                            dropdown: _withCtx(() => [
                              _createVNode(_component_el_dropdown_menu, null, {
                                default: _withCtx(() => [
                                  _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    command: "handleResetPwd",
                                    icon: _unref(Key)
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_15
                                    ]),
                                    _: 1
                                  }, 8, ["icon"])), [
                                    [_directive_hasPermi, ['system:user:resetPwd']]
                                  ]),
                                  _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    command: "handleAuthRole",
                                    icon: _unref(Check)
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_16
                                    ]),
                                    _: 1
                                  }, 8, ["icon"])), [
                                    [_directive_hasPermi, ['system:user:edit']]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "text",
                                icon: _unref(ArrowRight)
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              }, 8, ["icon"])
                            ]),
                            _: 2
                          }, 1032, ["onCommand"])), [
                            [_directive_hasPermi, ['system:user:resetPwd', 'system:user:edit']]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, loading.value]
            ]),
            _withDirectives(_createVNode(_component_pagination, {
              total: total.value,
              page: queryParams.pageNum,
              "onUpdate:page": _cache[6] || (_cache[6] = ($event: any) => ((queryParams.pageNum) = $event)),
              limit: queryParams.pageSize,
              "onUpdate:limit": _cache[7] || (_cache[7] = ($event: any) => ((queryParams.pageSize) = $event)),
              onPagination: getList
            }, null, 8, ["total", "page", "limit"]), [
              [_vShow, total.value > 0]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: title.value,
      modelValue: open.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((open).value = $event)),
      width: "600px",
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitForm
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { onClick: cancel }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "用户昵称",
                      prop: "nickName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.nickName,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.nickName) = $event)),
                          placeholder: "请输入用户昵称",
                          maxlength: "30"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "归属部门",
                      prop: "deptId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Treeselect), {
                          modelValue: form.deptId,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.deptId) = $event)),
                          options: deptOptions.value,
                          "show-count": true,
                          placeholder: "请选择归属部门"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "手机号码",
                      prop: "phonenumber"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.phonenumber,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.phonenumber) = $event)),
                          placeholder: "请输入手机号码",
                          maxlength: "11"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "邮箱",
                      prop: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.email,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.email) = $event)),
                          placeholder: "请输入邮箱",
                          maxlength: "50"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    (form.userId === undefined)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "用户名称",
                          prop: "userName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: form.userName,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.userName) = $event)),
                              placeholder: "请输入用户名称",
                              maxlength: "30"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    (form.userId === undefined)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "用户密码",
                          prop: "password"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: form.password,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.password) = $event)),
                              placeholder: "请输入用户密码",
                              type: "password",
                              maxlength: "20",
                              "show-password": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "用户性别" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.sex,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.sex) = $event)),
                          placeholder: "请选择性别"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dict.type.sys_user_sex, (dict) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: dict.value,
                                label: dict.label,
                                value: dict.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: form.status,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.status) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dict.type.sys_normal_disable, (dict) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                key: dict.value,
                                label: dict.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(dict.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "岗位" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.postIds,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.postIds) = $event)),
                          multiple: "",
                          placeholder: "请选择岗位"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postOptions.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.postId,
                                label: item.postName,
                                value: item.postId,
                                disabled: item.status == 1
                              }, null, 8, ["label", "value", "disabled"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "角色" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.roleIds,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.roleIds) = $event)),
                          multiple: "",
                          placeholder: "请选择角色"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleOptions.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.roleId,
                                label: item.roleName,
                                value: item.roleId,
                                disabled: item.status == 1
                              }, null, 8, ["label", "value", "disabled"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "备注" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.remark,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.remark) = $event)),
                          type: "textarea",
                          placeholder: "请输入内容"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: upload.title,
      modelValue: upload.open,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((upload.open) = $event)),
      width: "400px",
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitFileForm
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[21] || (_cache[21] = ($event: any) => (upload.open = false))
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElUpload), {
          ref_key: "uploadRef",
          ref: uploadRef,
          limit: 1,
          accept: ".xlsx, .xls",
          headers: upload.headers,
          action: upload.url + '?updateSupport=' + upload.updateSupport,
          disabled: upload.isUploading,
          "on-progress": handleFileUploadProgress,
          "on-success": handleFileSuccess,
          "auto-upload": false,
          drag: ""
        }, {
          tip: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_checkbox, {
                modelValue: upload.updateSupport,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((upload.updateSupport) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_22
            ]),
            _hoisted_23,
            _createVNode(_component_el_link, {
              type: "primary",
              underline: false,
              style: {"font-size":"12px","vertical-align":"baseline"},
              onClick: importTemplate
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFilled))
              ]),
              _: 1
            }),
            _hoisted_20
          ]),
          _: 1
        }, 8, ["headers", "action", "disabled"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})